import _objectSpread from '@babel/runtime/helpers/objectSpread2';
import _objectWithoutProperties from '@babel/runtime/helpers/objectWithoutProperties';
import * as React from 'react';
import { createElement } from 'react';
import { Draggable } from 'react-beautiful-dnd';
import { useDndContext } from '../DndContext/DndContext.js';
import { jsx, jsxs, Fragment } from 'react/jsx-runtime';

var _excluded = ["children", "dragData", "draggableId"];
var Context = /*#__PURE__*/React.createContext(null);
var DndDraggable = function DndDraggable(_ref) {
  var children = _ref.children,
    dragData = _ref.dragData,
    draggableId = _ref.draggableId,
    draggableProps = _objectWithoutProperties(_ref, _excluded);
  var dndContext = useDndContext();
  React.useEffect(function () {
    dndContext === null || dndContext === void 0 ? void 0 : dndContext.setDragDataByItemId(draggableId, dragData);
  }, [dndContext, dragData, draggableId]);
  return /*#__PURE__*/createElement(Draggable, _objectSpread(_objectSpread({}, draggableProps), {}, {
    draggableId: draggableId,
    key: draggableId
  }), function (draggableProvided, draggableSnapshot, draggableRubric) {
    return /*#__PURE__*/jsx(Context.Provider, {
      value: {
        dragData: dragData
      },
      children: typeof children === "function" ? children(draggableProvided, draggableSnapshot, draggableRubric) : /*#__PURE__*/jsxs(Fragment, {
        children: [/*#__PURE__*/jsx("div", _objectSpread(_objectSpread(_objectSpread({}, draggableProvided.dragHandleProps), draggableProvided.draggableProps), {}, {
          ref: draggableProvided.innerRef,
          children: children
        })), draggableSnapshot.isDragging && /*#__PURE__*/jsx("div", {
          children: children
        })]
      })
    });
  });
};
DndDraggable.displayName = "DndDraggable";

export { DndDraggable };
